import { Box, Grid, Paper, Stack, Typography, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router';
import categories from './categories';

function CategoryBlock({ title }) {
  const matches = useMediaQuery('(min-width:405px)');
  const matches320 = useMediaQuery('(min-width:320px)');
  const navigate = useNavigate();
  return (
    <Paper variant="elevation" elevation={0} sx={{ ml: '-10px', mr: '2px' }}>
      <Grid container style={{ marginTop: '-15px' }}>
        <Grid item mb={2}>
          {title}
        </Grid>
        <Grid
          container
          columns={3}
          gridColumn={3}
          gridRow={2}
          spacing={3}
          m={1}
          py={0.5}
          sx={{
            border: '1px solid #ddd',
            borderRadius: 5,
            justifyContent: 'space-around',
          }}
        >
          {categories.map((category, index) => (
            <Grid
              item
              sx={{
                paddingLeft: matches
                  ? '25px !important'
                  : matches320
                  ? '15px !important'
                  : '10px !important',
              }}
            >
              <Stack
                spacing={2}
                justifyContent={'center'}
                alignItems={'center'}
                onClick={() => navigate(category.href)}
              >
                <Box
                  sx={{
                    width: '60px',
                    height: '60px',
                    borderRadius: '50%',
                    background: '#EFF1FA',
                    justifySelf: 'center',
                    display: 'grid',
                    objectPosition: 'center',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingLeft: 0,
                    marginRight: 1,
                  }}
                >
                  <p>{category.icon} </p>
                </Box>
                <Typography
                  sx={{
                    fontSize: '.8rem',
                    fontWeight: '700',
                  }}
                >
                  {category.label}
                </Typography>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Paper>
  );
}

export default CategoryBlock;
